import { PMC } from "@app/models/PMC";
import { ContactApi } from "@app/services/apiServices/ContactApi";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { SpinnerService } from "@app/services/spinner.service";
import { take } from "rxjs/operators";
import { Component, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";

/**
 * Created by mac74191 on 4/18/17.
 */
@Component({
    selector: 'app-hoa-details',
    template: require('./hoadetails.html')
})
export class HoaDetailsComponent {

    pmcCouponId: number;
    pmc: PMC;
    name: string;
    doneLoading: boolean;

    constructor(@Inject(ContactApi) private contactApi: ContactApi,
                @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
                @Inject(SpinnerService) private spinnerService: SpinnerService,
                @Inject(Router) private router: Router,
                @Inject(ActivatedRoute) private route: ActivatedRoute) {

        if (this.route.snapshot.params.pmcCouponId) {
            spinnerService.closeSpinner();
            this.pmcCouponId = this.route.snapshot.params.pmcCouponId;
            this.doneLoading = false;
            this.getPMCDetails().pipe(take(1)).subscribe({ next: () => {
                spinnerService.closeSpinner();
                this.doneLoading = true;
            }, error: () => {
                this.doneLoading = true;
            } });
        }
    }

    // Change to retrieve the pmc details
    getPMCDetails() {
        return new Observable(observe => {
            try{
                this.contactApi.pmcOrganizationDetailsGET(false, this.pmcCouponId.toString())
                    .pipe(take(1)).subscribe({ next: (data) => {
                        if (data != null) {
                            this.pmc = data;
                        } else {
                            observe.error();
                        }
                        observe.next(undefined);
                    }, error: (err) => {
                        this.networkErrorService.handleNetworkError(err, true)
                            .pipe(take(1)).subscribe((resp) => {
                                if (resp === true) {
                                    this.getPMCDetails();
                                }
                                observe.error();
                            });

                    } })
            } catch(err) {
                this.networkErrorService.handleNetworkError(err, true)
                    .pipe(take(1)).subscribe((resp) => {
                        if (resp === true) {
                            this.getPMCDetails();
                        }
                        observe.error();
                    });
            }

        });
    }

    cancel() {
        this.router.navigateByUrl('/properties');
    }
}
